import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class BP42Analytics extends BaseAnalytics {
    constructor(category = 'BP42Category') {
        super();
        this.category = category;
    }

    public popupOpened(): void {
        return;
    }

    public startedFillingName(tariffName: string): void {
        this.send('started', `${tariffName} | short_form`);
    }

    // 'tariffName' is defined but never used.
    // eslint-disable-next-line
    public startedFillingPhone(tariffName: string): void {
    }

    // 'tariffName' is defined but never used.
    // eslint-disable-next-line
    public requestSent(tariffName: string): void {
    }

    public successRequest(tariffName: string, message: string, uid?: number): void {
        if (uid) {
            this.send('finished', `${tariffName} | short_form | ${message}`, { uid });
        } else {
            this.send('finished', `${tariffName} | short_form | ${message}`);
        }
    }

    public failureRequest(tariffName: string, uid?: number): void {
        if (uid) {
            this.send('error', `${tariffName} | short_form | Не удалось отправить заявку.`, { uid });
        } else {
            this.send('error', `${tariffName} | short_form | Не удалось отправить заявку.`);
        }
    }

    public clickedSpecialOffer(tariffName: string): void {
        this.send('click_continue_online', `${tariffName} | short_form`);
    }

    public clickedClosePopup(): void {
        return;
    }

    public clickedSubmit(): void {
        return;
    }
}

export const analytics = new BP42Analytics('application_form');

export default BP42Analytics;
